(() => {
  const FILTERS_ROOT_SELECTOR = '#main-collection-filters';
  const PRIMARY_CLASS = 'shop-reset-primary';
  const HIDDEN_CLASS = 'shop-reset-hidden';

  let observer;
  let scheduled = false;

  function getFiltersRoot() {
    return document.querySelector(FILTERS_ROOT_SELECTOR);
  }

  function findAllResetBlocks(root) {
    // Keep your existing list here if different
    return Array.from(
      root.querySelectorAll('.active-facets, .facets__active-facets, .facets__reset')
    ).filter(Boolean);
  }

  function pickPrimary(blocks) {
    // Prefer .active-facets if present (your Day 2 rule)
    return blocks.find(el => el.classList.contains('active-facets')) || blocks[0] || null;
  }

  function movePrimaryToBottom(root, primary) {
    // Choose a stable “bottom” location. In Dawn, a safe bet is end of the facets form/container.
    // If you already target a container inside #main-collection-filters, keep it.
    const container =
      root.querySelector('.facets') ||
      root.querySelector('form') ||
      root;

    // If it's already the last element in that container, do nothing.
    if (primary.parentElement === container && primary === container.lastElementChild) return;

    container.appendChild(primary);
  }

  function normalizeText(primary) {
    // Make this conservative: change only the visible string, don’t rewrite innerHTML.
    const link = primary.querySelector('a, button');
    if (!link) return;

    // Avoid re-writing every time (can cause flicker in some themes)
    const desired = 'Remove all filters';
    if (link.textContent.trim() !== desired) {
      link.textContent = desired;
    }
    link.setAttribute('aria-label', desired);
  }

  function applyTweaks() {
    const root = getFiltersRoot();
    if (!root) return;

    // Disconnect while we manipulate so we don’t trigger our own observer loop
    if (observer) observer.disconnect();

    try {
      const blocks = findAllResetBlocks(root);
      if (!blocks.length) return;

      const primary = pickPrimary(blocks);
      if (!primary) return;

      // Mark primary + hide the rest (without removing)
      blocks.forEach(el => {
        if (el === primary) {
          el.classList.add(PRIMARY_CLASS);
          el.classList.remove(HIDDEN_CLASS);
        } else {
          el.classList.remove(PRIMARY_CLASS);
          el.classList.add(HIDDEN_CLASS);
        }
      });

      movePrimaryToBottom(root, primary);
      normalizeText(primary);
    } finally {
      // Reconnect observer
      observer = new MutationObserver(schedule);
      observer.observe(root, { childList: true, subtree: true });
    }
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;

    // Debounce into the next paint; Dawn often mutates multiple times per update.
    requestAnimationFrame(() => {
      scheduled = false;
      applyTweaks();
    });
  }

  // CSS class to hide duplicates (add to base.css)
  // .shop-reset-hidden { display: none !important; }

  document.addEventListener('DOMContentLoaded', () => {
    const root = getFiltersRoot();
    if (!root) return;

    observer = new MutationObserver(schedule);
    observer.observe(root, { childList: true, subtree: true });

    applyTweaks(); // initial
  });

  // If your theme uses section rendering events, this makes it even steadier:
  document.addEventListener('shopify:section:load', schedule);
})();






